import { extractGroupBySettings } from '@keen.io/query';
import { defaultTransformation } from './default-transformation';
import { categoricalTransformation } from './categorical-transformation';
import { COLUMN_JOIN } from '../../constants';
export var transform = function (_a) {
    var query = _a.query, chartSettings = _a.chartSettings;
    var data = chartSettings.data, keys = chartSettings.keys, yScaleSettings = chartSettings.yScaleSettings, stackMode = chartSettings.stackMode;
    var valueFormatter = yScaleSettings === null || yScaleSettings === void 0 ? void 0 : yScaleSettings.formatLabel;
    var groupBy = query.group_by;
    var isCategoricalAnalysis = groupBy && extractGroupBySettings(groupBy).length > 0;
    if (isCategoricalAnalysis) {
        var groupColumnName = extractGroupBySettings(groupBy).join(COLUMN_JOIN);
        return categoricalTransformation(data, keys, valueFormatter, groupColumnName, stackMode === 'percent');
    }
    else {
        return defaultTransformation(data, keys, valueFormatter);
    }
};
